import Store from '../Store';

export const getCombinedState = <State, T>(
    stores: Store<unknown>[] | Store<State>[],
    selector?: (...args: State[] | unknown[]) => T,
): State | T =>
    selector
        ? selector(...stores.map((store) => store.value))
        : (stores as [Store<State>])[0].value;
